import { render, staticRenderFns } from "./extension.vue?vue&type=template&id=7fc83522&scoped=true&"
import script from "./extension.vue?vue&type=script&lang=js&"
export * from "./extension.vue?vue&type=script&lang=js&"
import style0 from "./extension.vue?vue&type=style&index=0&id=7fc83522&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc83522",
  null
  
)

export default component.exports